import Icon from './Icon'

export default Icon



//////////////////
// WEBPACK FOOTER
// ./~/buefy/src/components/icon/index.js
// module id = 280
// module chunks = 55